export default __webpack_public_path__ + "static/media/application_exclamation_icon.c0281c85.svg";